export default {
  ADD: 'notifications/ADD',
  REMOVE: 'notifications/REMOVE',
}
